import * as React from 'react';
import cx from 'classnames';
import Link from 'components/link/link';

type Props = {
    logo?: React.ReactNode;
    isActive?: boolean;
    closeAction?: React.ReactNode;
    menuList?: React.ReactNode[];
    downloadAction?: React.ReactNode;
    jsClass?: string;
    jsBackDropClass?: string;
    closePanel?: (...args: any[]) => any;
};

/**
 * Make screen width < 1024 px in order to see the component
 */
function MobilePanel(props: Props) {
    const {
        logo,
        isActive,
        closeAction,
        menuList,
        downloadAction,
        closePanel,
        jsClass = 'js-mobile-navigation',
    } = props;

    const className = {
        block: cx({
            'mobile-panel': true,
            'is-active': isActive,
            [jsClass]: jsClass,
        }),
        backdrop: cx({
            'mobile-panel__backdrop': true,
        }),
    };

    return (
        <div className={className.block}>
            <div className="mobile-panel__inner">
                <div className="mobile-panel__header">
                    {logo ? <div className="mobile-panel__logo">{logo}</div> : null}
                    <div className="mobile-panel__close">{closeAction}</div>
                </div>

                {menuList ? (
                    <div className="mobile-panel__content">
                        {menuList.map((menu, index) => (
                            <div
                                className="mobile-panel__content-menu"
                                key={`mobile-panel-content-menu-${index}`}
                            >
                                {menu}
                            </div>
                        ))}
                    </div>
                ) : null}

                <div className="mobile-panel__download-app">{downloadAction}</div>

                <div className="mobile-panel__socials" id="footer">
                    <div className="flex social-icons md:h-center">
                        <Link
                            href="https://www.tiktok.com/@bumble"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/tiktok.svg?v=1"
                                alt="TikTok"
                            />
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/tiktok_hover.svg?v=1"
                                alt="TikTok"
                            />
                        </Link>
                        <Link href="https://twitter.com/bumble" target="_blank" rel="noreferrer">
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/twitter.svg?v=1"
                                alt="Twitter"
                            />
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/twitter_hover.svg?v=1"
                                alt="Twitter"
                            />
                        </Link>
                        <Link
                            href="https://www.instagram.com/bumble"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/instagram.svg?v=1"
                                alt="Instagram"
                            />
                            <img
                                src="/date/seasonal/icons/instagram_hover.svg?v=1"
                                alt="Instagram"
                            />
                        </Link>
                        <Link
                            href="https://www.facebook.com/bumbleapp"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/facebook.svg?v=1"
                                alt="Facebook"
                            />
                            <img src="/date/seasonal/icons/facebook_hover.svg?v=1" alt="Facebook" />
                        </Link>
                        <Link
                            href="https://www.youtube.com/c/bumble"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/youtube.svg?v=1"
                                alt="Youtube"
                            />
                            <img
                                style={{ height: '36px', width: '36px' }}
                                src="/date/seasonal/icons/youtube_hover.svg?v=1"
                                alt="Youtube"
                            />
                        </Link>
                    </div>
                </div>
            </div>

            <div className={className.backdrop} onClick={closePanel}></div>
        </div>
    );
}

export default MobilePanel;
